export default __webpack_public_path__ + "images/LI.604b272.png";